import { Plus } from "lucide-react";
import { MARQUEE_ITEMS } from "../../data/content";

export const Marquee = () => (
    <div data-testid="marquee-strip" className="overflow-hidden border-y border-ink/10 bg-white py-5">
        <div className="marquee-track flex w-max items-center gap-8 pr-8">
            {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
                <span key={i} className="flex items-center gap-8">
                    <span className="whitespace-nowrap font-display text-2xl font-light italic text-ink/80">
                        {item}
                    </span>
                    <Plus className="h-4 w-4 shrink-0 text-teal-accent" />
                </span>
            ))}
        </div>
    </div>
);
